export class Mention {
    constructor(
        public idMention?: number,
        public code?: string,
        public llMention?: string,
    ) { }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/grhum/mention.model.ts